import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/* Header */
import { MessagesComponent } from '../../components/messages/messages.component';
import { ConversazioniComponent } from '../../components/conversazioni/conversazioni.component';

/* Loader */
import { GenericLoaderComponent } from '../../components/loaders/generic-loader/generic-loader.component';
import { LoaderWrapperComponent } from '../../components/loaders/loader-wrapper/loader-wrapper.component';
import { LoaderFullComponent } from '../../components/loaders/loader-full/loader-full.component';

/* Core */
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { ContentComponent } from '../../components/content/content.component';
import { FooterComponent } from '../../components/footer/footer.component';

import { UncertificatedComponent } from '../../components/uncertificated/uncertificated.component';
import { AppComponentGenericComponent } from '../../components/custom/app-component-generic/app-component-generic.component';
import { ModalWrapperComponent } from '../../components/modals/modal-wrapper/modal-wrapper.component';
import { TableGenericComponent } from '../../components/custom/table-generic/table-generic.component';
import { FilterBoxGenericComponent } from '../../components/custom/filter-box-generic/filter-box-generic.component';

import { AuthGuard } from '../../guards/auth.guard';

const routes: Routes = [
	{ path: 'uncertificated', component: UncertificatedComponent },
	{ path: 'check-access', component: LoaderFullComponent },
	{ path: 'conversazioni', component: ConversazioniComponent, canActivate:[AuthGuard]},
	{ path: 'conversazioni/:id', component: ConversazioniComponent, canActivate:[AuthGuard] },
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);
